import {remCalc} from '_themeUtils'

const animatedSlide = {
    AnimatedSlide: {
        baseStyle: ({headerSize, headerSizeNotCollapsed, headerSizeCollapsedWithoutBanner, accessibilityBannerSize, isWide, isUltrawide, hasDynamicBottomBar}) => {
            // Mobile viewport unit for slide height.
            // Default (desktop/tablet, Android, "old" Safari): 100vh, as before.
            // Only when a dynamic bottom browser bar is detected (iOS 26-style Liquid Glass, or any
            // browser with the same collapsing bar) switch to 100svh so the slide is pinned to the
            // "bar visible" height and stays large/stable: with 100vh the slide would expand while
            // the bar collapses and never shrink back when the bar returns large, causing glitching.
            const mobileViewportUnit = hasDynamicBottomBar ? '100svh' : '100vh'

            return {
            container: {
                w: '100%',
                boxSizing: 'border-box',
                h: {
                    base: `calc(${mobileViewportUnit} - ${headerSizeCollapsedWithoutBanner?.base || headerSize.base}px)`,
                    sm: `calc(${mobileViewportUnit} - ${headerSizeCollapsedWithoutBanner?.sm || headerSize.sm}px)`,
                    md: `calc(100dvh - ${headerSizeCollapsedWithoutBanner?.md || headerSize.md}px)`,
                    lg: `calc(100dvh - ${headerSizeCollapsedWithoutBanner?.lg || headerSize.lg}px)`,
                    xl: `calc(100dvh - ${accessibilityBannerSize.xl || 0}px)`,
                    '2xl': `calc(100dvh - ${accessibilityBannerSize['2xl'] || 0}px)`,
                },
                position: 'relative',

                '&.not-on-first-slide': {
                    boxSizing: 'content-box',
                    pb: 0,
                    mt: {
                        base: `-${headerSizeNotCollapsed.base - (headerSizeCollapsedWithoutBanner?.base || headerSize.base)}px`,
                        sm: `-${headerSizeNotCollapsed.sm - (headerSizeCollapsedWithoutBanner?.sm || headerSize.sm)}px`,
                        md: `-${headerSizeNotCollapsed.md - (headerSizeCollapsedWithoutBanner?.md || headerSize.md)}px`,
                        lg: `-${headerSizeNotCollapsed.lg - (headerSizeCollapsedWithoutBanner?.lg || headerSize.lg)}px`,
                        xl: 0,
                        '2xl': 0,
                    },
                },

                '.swiper.cc-animated-slide-swiper': {
                    w: '100%',
                    h: '100%',
                    overflow: 'hidden',

                    '.swiper-slide': {
                        overflowY: 'auto',
                        WebkitOverflowScrolling: 'touch',
                        backfaceVisibility: 'hidden',

                        // add lateral padding for ultrawide or short mobile vieports

                        '& .cc-pd-double-same[data-items-layout="close_padded"]': {
                            ...(isWide && {
                                px: remCalc(80),
                            }),
                            ...(isUltrawide && {
                                px: remCalc(250),
                            }),
                        },

                        '& .cc-pd-wall-mixed[data-columns="3"]': {
                            ...(isWide && {
                                px: remCalc(125),
                            }),
                            ...(isUltrawide && {
                                px: remCalc(275),
                            }),
                        },

                        '& .cc-pd-wall-mixed[data-columns="4"]': {
                            ...(isWide && {
                                px: remCalc(50),
                            }),

                            ...(isUltrawide && {
                                px: remCalc(125),
                            }),
                        },
                    },

                    '&.swiper-creative .swiper-slide': {
                        overflowX: 'hidden !important',
                        zIndex: '1 !important',
                    },

                    '&.swiper-creative .swiper-slide-active': {
                        zIndex: '3 !important',
                    },

                    '&.swiper-creative .swiper-slide-prev': {
                        zIndex: '2 !important',
                    },

                    '&.swiper-creative .swiper-slide-next': {
                        zIndex: '4 !important',
                    },

                    '&.swiper-creative.is-reverse-transition .swiper-slide-prev': {
                        zIndex: '4 !important',
                    },

                    '&.swiper-creative.is-reverse-transition .swiper-slide-next': {
                        zIndex: '2 !important',
                    },

                    // `:first-of-type` (not `:first-child`) — emotion warns that `:first-child` is unsafe
                    // for SSR. The `.swiper-slide`s are all sibling elements of the same type, so the two
                    // selectors are equivalent here.
                    '.swiper-slide:not(:first-of-type)': {
                        pt: {
                            xl: 0,
                            '2xl': 0,
                        },
                    },

                    '.swiper-pagination': {
                        right: 'spacing.8',

                        '.swiper-pagination-bullet': {
                            w: remCalc(6),
                            h: remCalc(6),
                            my: 'spacing.2',
                            background: 'rgba(255, 255, 255, 0.5)',
                        },

                        '.swiper-pagination-bullet-active': {
                            background: 'color.border.white',
                        },
                    },
                },
            },
            moduleItemWrapper: {
                h: {base: '0', md: '100%'},
                minH: {base: '100%', md: 'unset'},
                display: 'flex',
                alignItems: 'center',
                background: 'color.border.white',
                overflow: {base: 'visible', lg: 'hidden'},
            },
            }
        },
    },
}

export default animatedSlide
